var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FilterSection',{attrs:{"title":_vm.title}},[_c('MultipleSelect',{attrs:{"id":("multi-select-amend-" + _vm.title),"items":_vm.multiSelectOptions,"config":_vm.multiSelectConfig},on:{"multipleSelection":_vm.toggleCheckbox}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }